import officialWebsiteList from '../../page/officialWebsitePublicity/companyAndManagerPage/officialWebsiteList';
import evaluationSituationDetail from '../../page/officialWebsitePublicity/companyAndManagerPage/evaluationSituationDetail';
import companyBaseDetail from '../../page/officialWebsitePublicity/companyAndManagerPage/companyPage/companyBaseDetail';
import officialCompanyBaseInfoDetailPenetrate from '../../page/officialWebsitePublicity/companyAndManagerPage/companyPage/companyBaseInfoDetailPenetrate';
import officialManagerBaseInfoDetail from '../../page/officialWebsitePublicity/companyAndManagerPage/managerPage/managerBaseInfoDetail';
import officialManagerBaseInfoDetailPenetrate from '../../page/officialWebsitePublicity/companyAndManagerPage/managerPage/managerBaseInfoDetailPenetrate';
import officialGoodInfoDetail from '../../page/officialWebsitePublicity/companyAndManagerPage/goodInfoDetail';
import officialBadInfoDetail from '../../page/officialWebsitePublicity/companyAndManagerPage/badInfoDetail';
import officialRiskInfoDetail from '../../page/officialWebsitePublicity/companyAndManagerPage/riskInfoDetail';

const officialWebsitePublicityRouter = [
    {
        path: '/officialWebsiteList',
        name: 'officialWebsiteList',
        component: officialWebsiteList,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive:true
        },
    },
    {
        path: '/evaluationSituationDetail',
        name: 'evaluationSituationDetail',
        component: evaluationSituationDetail,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false,
        },
    },
    {
        path: '/companyBaseDetail',
        name: 'companyBaseDetail',
        component: companyBaseDetail,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
    {
        path: '/officialCompanyBaseInfoDetailPenetrate',
        name: 'officialCompanyBaseInfoDetailPenetrate',
        component: officialCompanyBaseInfoDetailPenetrate,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
    {
        path: '/officialManagerBaseInfoDetail',
        name: 'officialManagerBaseInfoDetail',
        component: officialManagerBaseInfoDetail,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
    {
        path: '/officialManagerBaseInfoDetailPenetrate',
        name: 'officialManagerBaseInfoDetailPenetrate',
        component: officialManagerBaseInfoDetailPenetrate,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
    {
        path: '/officialGoodInfoDetail',
        name: 'officialGoodInfoDetail',
        component: officialGoodInfoDetail,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
    {
        path: '/officialBadInfoDetail',
        name: 'officialBadInfoDetail',
        component: officialBadInfoDetail,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
    {
        path: '/officialRiskInfoDetail',
        name: 'officialRiskInfoDetail',
        component: officialRiskInfoDetail,
        meta: {
            right: [],
            isShowMenu: false,
            keepAlive: false
        },
    },
];

export default officialWebsitePublicityRouter;
